import {Col, Modal, Row} from "react-bootstrap";
import {AppContext} from "../../lib/AppContext";
import React, {useContext, useEffect, useRef, useState} from "react";
import {handleDefaultValues} from "../common/Utils";
import {useForm} from 'react-hook-form';
import MDButton from "../../components/MDButton";
import Grid from "@mui/material/Grid";
import MDBox from "../../components/MDBox";
import MDInput from "../../components/MDInput";
import {CKEditor} from "@ckeditor/ckeditor5-react";
import {ButtonView, ClassicEditor, FileRepository} from "ckeditor5";
import {CONFIG} from "../common/EditorConfig";
import Divider from "@mui/material/Divider";
import {getCommunicationTemplate, massEmail, uploadTemplateFile} from "../common/api/WebApi";

export default function ComposeEmailModal({emailTemplate, recipients, show, saving, handleClose, handleSave}) {

  const [context, setContext] = useContext(AppContext);
  const [templateIndex, setTemplateIndex] = useState(1);

  const [sending, setSending] = useState(false);
  const [handledTemplate, setHandledTemplate] = useState(null);
  const {register, handleSubmit, setValue, control} = useForm({
    values: handleDefaultValues(emailTemplate)
  });

  useEffect(() => {
    if (!emailTemplate?.guid) {
      return;
    }
    getCommunicationTemplate(emailTemplate?.guid).then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setEmail({
          recipientGuids: recipients,
          emailSubject: result.templateSubject,
          emailBody: result.templateBody,
        });
        setValue('emailSubject', result?.templateSubject);
        setTemplateIndex(templateIndex + 1);
      }
    });
  }, [emailTemplate])

  const handleCloseNote = () => {
    handleClose();
  };

  const handleSendEmail = (data) => {
    let _d = {...data};
    _d.recipientGuids = recipients;

    const editorData = editorRef.current.getData();

    const cleaned = editorData
      .replace(/^<p>/i, '<div>')
      .replace(/<\/p>$/i, '</div>');

    _d.emailBody = cleaned;

    setSending(true);
    massEmail(_d).then((resp) => {
      setSending(false);
      handleSave();
    });
  }

  const handleSaveNote = (data) => {
    // handleSave(data);
    handleSave();
  };

  const [email, setEmail] = useState({});
  const [emailBody, setEmailBody] = useState();

  function uploadAdapter(loader) {
    return {
      upload: () => {
        return new Promise((resolve, reject) => {

          const body = new FormData();
          loader.file.then((file) => {
            const fileType = file.type;
            const fileName = file.name;
            const reader = new FileReader();

            reader.onload = function (evt) {
              let fileRequest = {
                imageType: fileType,
                imageName: fileName,
                data: btoa(evt.target.result)
              }

              uploadTemplateFile(fileRequest).then(result => {
                if (result.error) {
                  setContext({...context, error: {message: result.message}});
                } else {
                  loader.uploaded = true;
                  loader.uploadUrl = result;
                }
                resolve({
                  default: result.fileLocation
                })
              });
            }
            reader.readAsBinaryString(file);
          });
        })
      }
    }
  }

  const [blurEditor, setBlurEditor] = useState();

  const insertText = (text) => {
    blurEditor.model.change(writer => {
      writer.insertText(text + " ", blurEditor.model.document.selection.getFirstPosition());
    });
  };

  const handleChange = (e, editor) => {
    setEmailBody(editor.getData());
  }

  const editorRef = useRef(null);

  const handleReady = (editor) => {
    editorRef.current = editor;
    setBlurEditor(editor);
  };

  const handleBlur = (event, editor) => {
    setBlurEditor(editor);
  };

  function uploadPlugin(editor) {
    editor.plugins.get(FileRepository).createUploadAdapter = (loader) => {
      return uploadAdapter(loader);
    };
  }

  const [preview, setPreview] = useState();
  const [showPreview, setShowPreview] = useState(false);

  function previewPlugin(editor) {
    editor.ui.componentFactory.add('preview', (locale) => {
      const view = new ButtonView(locale);

      view.set({
        label: 'Preview',
        tooltip: true,
        withText: true
      });

      view.on('execute', () => {
        const data = editor.getData();
        setPreview(data);
        setShowPreview(true);
        return;
        const previewWindow = window.open('', '_blank');
        previewWindow.document.write(data);
        previewWindow.document.close();
      });

      return view;
    });
  }

  return (
    <Modal onHide={handleCloseNote} size={'lg'} show={show} enforceFocus={false} className={'compose-email-modal'}>
      <form
        onSubmit={handleSubmit(handleSendEmail)} id={'noteForm'}>
        <Modal.Header closeButton>
          <Modal.Title>Compose Email</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col className={'col col-main'} xs={12}>
              <>
                <Row>
                  <Col className={'col'} sm={12} xs={12}>
                    <h6>{recipients?.length + ' Recipients'}</h6>
                  </Col>
                </Row>
                <Row>
                  <Col className={'col'} sm={12} xs={12}>
                    <Grid container spacing={3}>
                      <Grid item xs={12} id="company-info">
                        <>
                          {templateIndex > 0 &&

                            <MDBox p={3}>
                              <Row>
                                <Col className={'col'} sm={12} xs={12}>
                                  <div className="form-group my-2">
                                    <MDInput
                                      variant="outlined" type="text"
                                      {...register('emailSubject')}
                                      autoComplete="off" required
                                      InputLabelProps={{shrink: true}}
                                      className="form-control" id="emailSubject"
                                      label="Enter Subject"/>
                                  </div>
                                </Col>
                              </Row>

                              <Row>
                                <Col className={'col'} sm={12} xs={12} className={'compose-email-editor'}>

                                  <CKEditor
                                    editor={ClassicEditor}
                                    config={{
                                      htmlSupport: {
                                        allow: [
                                          {
                                            name: /.*/,
                                            attributes: true,
                                            classes: true,
                                            styles: true
                                          }
                                        ]
                                      },
                                      placeholder: 'Enter Email Body',
                                      toolbar: CONFIG.TOOLBAR,
                                      plugins: CONFIG.PLUGINS,
                                      extraPlugins: [
                                        uploadPlugin,
                                        previewPlugin
                                      ]
                                    }}
                                    data={email?.emailBody || ''}
                                    onReady={editor => {
                                      handleReady(editor);
                                    }}
                                    onChange={(event, editor) => {
                                      handleChange(event, editor);
                                    }}
                                    onBlur={(event, editor) => {
                                      handleBlur(event, editor);
                                    }}
                                    onFocus={(event, editor) => {
                                    }}
                                  />

                                  <Divider/>
                                </Col>
                              </Row>

                            </MDBox>}
                        </>
                      </Grid>
                    </Grid>
                  </Col>
                </Row>
              </>
            </Col>
          </Row>

        </Modal.Body>
        <Modal.Footer>
          <MDButton type="submit" color="info" disabled={sending}>
            {sending ? 'Sending...' : 'Send'}
          </MDButton>
        </Modal.Footer>
      </form>
    </Modal>
  );
}